import $ from 'jquery';


/* Global variables
********************************************/



/* Site search
********************************************/

$('.js-main-search-toggle').on('click', function (e) {
	e.preventDefault();
	$(this).toggleClass('is-active');
	$('.js-main-search').toggleClass('is-active');
	$('.js-main-search .c-page-search__field').focus();
	$('.js-main-search .c-form-element__field input').focus();

	if ( $( 'html' ).hasClass( 'has-search-open' ) ) {
		$('html').removeClass('has-search-open');
		$( this ).closest( '.js-main-search' ).find( '.wp_autosearch_input' ).val('');
		$( this ).closest( '.js-main-search' ).find( '.wp_autosearch_suggestions' ).hide();
	}
});

$(document).on('click', function (e) {
	if (!$(e.target).closest('.js-main-search').length) {
		$('.js-main-search-toggle').removeClass('is-active');
		$('.js-main-search').removeClass('is-active');
		$('html').removeClass('has-search-open');
	}
});

$('.js-main-search-popup').on('click', function (e) {
	$(this).addClass('is-active');
});

$(document).on('click', function (e) {
	if (!$(e.target).closest('.js-main-search-popup').length) {
		$('.js-main-search-popup').removeClass('is-active');
	}
});
// Close navigation when hit escape key
$('.js-main-search-popup').on("keydown", function (e) {
	if (e.keyCode == "27") {
		$('.js-main-search-popup').removeClass('is-active');
		$('html').removeClass('has-search-open');
	}
});
